import { defineMessages } from 'react-intl'

export const homeDeviceInformationMessages = defineMessages({
  backToAllDevices: {
    id: 'deviceInformation.backArrow',
    description: 'Text for return button',
    defaultMessage: 'Back to All Devices',
  },
  deviceUID: {
    id: 'deviceInformation.deviceUID',
    desctiption: 'Device UID text',
    defaultMessage: 'Device UID',
  },
  deviceTypeLabel: {
    id: 'deviceinfoemation.deviceTypeLabel',
    description: 'Device Type label',
    defaultMessage: 'Device Type',
  },
  deviceModelLabel: {
    id: 'deviceInformation.deviceModelLabel',
    description: 'Device Model label',
    defaultMessage: 'Device Model',
  },
  deviceZoneLabel: {
    id: 'deviceInformation.deviceZoneLabel',
    description: 'Device Zone label',
    defaultMessage: 'Zone',
  },
  deviceStatusOnline: {
    id: 'deviceInformation.deviceStatusOnline',
    description: 'Device status online',
    defaultMessage: 'Device Online',
  },
  deviceStatusOffline: {
    id: 'deviceInformation.deviceStatusOffline',
    description: 'Device status offline',
    defaultMessage: 'Device offline',
  },
  deviceStatusCardDisconnected: {
    id: 'deviceInformation.deviceStatusCardDisconnected',
    description: 'Status text showing that device is disconnected',
    defaultMessage: 'Disconnected',
  },
  deviceStatusCardConnected: {
    id: 'deviceInformation.deviceStatusCardConnected',
    description: 'Status text showing that device is connected',
    defaultMessage: 'Connected',
  },
  deviceStatusCardErrors: {
    id: 'deviceInformation.deviceStatusCardErrors',
    description: 'Status text showing that device has errors',
    defaultMessage: 'Errors',
  },
  deviceStatusCardWarnings: {
    id: 'deviceInformation.deviceStatusCardWarnings',
    description: 'Status text showing that device has warnings',
    defaultMessage: 'Warnings',
  },
  deviceStatusCardNA: {
    id: 'deviceInformation.deviceStatusCardNA',
    description: 'Status text showing that device is unavailable',
    defaultMessage: 'N/A',
  },
  deviceConnectionStatusLabel: {
    id: 'deviceInformation.deviceConnectionStatusLabel',
    description: 'Device Connection Status label',
    defaultMessage: 'Connection Status',
  },
  deviceBytesSentLabel: {
    id: 'deviceInformation.deviceBytesSentLabel',
    description: 'Device Bytes Sent label',
    defaultMessage: 'Bytes Sent',
  },
  deviceBytesReceivedLabel: {
    id: 'deviceInformation.deviceBytesReceivedLabel',
    description: 'Device Bytes Received label',
    defaultMessage: 'Bytes Received',
  },
  profileLabel: {
    id: 'deviceInformation.profileLabel',
    defaultMessage: 'Profile',
  },
  messagesReceivedLabel: {
    id: 'deviceInformation.messagesReceivedLabel',
    defaultMessage: 'Messages Received',
  },
  messagesSentLabel: {
    id: 'deviceInformation.messagesSentLabel',
    defaultMessage: 'Messages Sent',
  },
  receiveResponseTimeoutsLabel: {
    id: 'deviceInformation.receiveResponseTimeoutsLabel',
    defaultMessage: 'Receive Response Timeouts',
  },
  deviceUptimeLabel: {
    id: 'deviceInformation.deviceUptimeLabel',
    description: 'Device Uptime label',
    defaultMessage: 'Device Uptime',
  },
  deviceFirmwareLabel: {
    id: 'deviceInformation.deviceFirmwareLabel',
    description: 'Device Firmware label',
    defaultMessage: 'Firmware',
  },
  deviceFirmwareUpgradeLabel: {
    id: 'deviceInformation.deviceFirmwareUpgradeLabel',
    description: 'Device Firmware Upgrade label',
    defaultMessage: 'Firmware Upgrade',
  },
  deviceBootRomVersionLabel: {
    id: 'deviceInformation.deviceBootRomVersionLabel',
    description: 'Device Boot Rom Version label',
    defaultMessage: 'Boot Rom Version',
  },
  deviceSerialNumberLabel: {
    id: 'deviceInformation.deviceSerialNumberLabel',
    description: 'Device Serial Number label',
    defaultMessage: 'Serial #',
  },
  devicePartNumberLabel: {
    id: 'deviceInformation.devicepartNumberLabel',
    description: 'Device Part Number label',
    defaultMessage: 'Part #',
  },
  deviceIPAddress: {
    id: 'deviceInformation.deviceIPAddress',
    description: 'Device IP Address label',
    defaultMessage: 'IP Address',
  },
  deviceSoftwareVersion: {
    id: 'deviceInformation.deviceSoftwareVersion',
    description: 'Device Software Version label',
    defaultMessage: 'Software Version',
  },
  deviceWifi: {
    id: 'deviceInformation.deviceWifi',
    description: 'Device Wifi label',
    defaultMessage: 'Wifi',
  },
  deviceNetworkLevel: {
    id: 'deviceInformation.deviceNetworkLevel',
    description: 'Device Network Level label',
    defaultMessage: 'Network Level',
  },
  signalStrength: {
    id: 'deviceInformation.signalStrength',
    description: 'Cellular Signal Strength label',
    defaultMessage: 'Cellular Signal Strength',
  },
  weak: {
    id: 'deviceInformation.weak',
    description: 'Cellular Signal Strength',
    defaultMessage: 'Poor',
  },
  fair: {
    id: 'deviceInformation.fair',
    description: 'Cellular Signal Strength',
    defaultMessage: 'Fair',
  },
  good: {
    id: 'deviceInformation.good',
    description: 'Cellular Signal Strength',
    defaultMessage: 'Good',
  },
  strong: {
    id: 'deviceInformation.strong',
    description: 'Cellular Signal Strength',
    defaultMessage: 'Excellent',
  },
  noSignal: {
    id: 'deviceInformation.noSignal',
    description: 'Cellular Signal Strength',
    defaultMessage: 'No Signal',
  },
  notConnected: {
    id: 'deviceInformation.notConnected',
    description: 'No connection message',
    defaultMessage: 'not connected',
  },
})
